import { motion } from '@eversports/react-components/design-tokens/motion'
import Card from '@eversports/react-components/primitives/Card'
import Divider from '@eversports/react-components/primitives/Divider'
import ErrorBox from '@eversports/react-components/primitives/ErrorBox'
import Flex from '@eversports/react-components/primitives/Flex'
import Heading from '@eversports/react-components/primitives/Heading'
import MonetaryValue from '@eversports/react-components/primitives/MonetaryValue'
import Processing from '@eversports/react-components/primitives/Processing'
import Sticky from '@eversports/react-components/primitives/Sticky'
import Text from '@eversports/react-components/primitives/Text'
import { makeStyles } from '@mui/styles'

import useCheckoutContext from '../../data/useCheckoutContext'
import useSummary from '../../data/useSummary'
import { Localized } from '../../localization/react'
import AvailablePaymentMethods from '../AvailablePaymentMethods'
import { VoucherSelection } from '../VoucherSelection'
import CorporateBenefitsToggle from './CorporateBenefitsToggle'
import { SpotBookingInformation } from './SpotBookingInformation'

import SummaryButton from './SummaryButton'
import SummaryItems from './SummaryItems'

const useStyles = makeStyles({
  uppercase: {
    textTransform: 'uppercase',
  },
  container: {
    maxWidth: 'inherit',
    width: '100%',
  },
})

const DesktopSummary = () => {
  const classes = useStyles()
  const context = useCheckoutContext()
  const errors = context.getErrors()
  const { isLoading, items, total, isSettleWithAConfirmWithOption, showVoucher, hasSpotBooking } = useSummary()

  return (
    <div className={classes.container}>
      <Sticky boundaryEdge="top">
        <Flex verticalSpacing="dense" flexDirection="column">
          <Card padding="wide" raised>
            <Processing isLoading={context.isSummaryLoading}>
              <Flex flexDirection="column" verticalSpacing="wide">
                <Heading is="h1">
                  <Localized id="summary-title" />
                </Heading>
                <SummaryItems items={items} isSettleWithAConfirmWithOption={isSettleWithAConfirmWithOption} />
                <Divider />
                {!isSettleWithAConfirmWithOption && total && (
                  <Flex justifyContent="space-between" alignItems="center">
                    <Flex horizontalSpacing="dense" alignItems="center">
                      <span className={classes.uppercase}>
                        <Heading is="h6" variant="small">
                          <Localized id="summary-total" />
                        </Heading>
                      </span>
                      <Text size="small">
                        <Localized id="summary-total-vat" />
                      </Text>
                    </Flex>
                    <Processing isLoading={isLoading}>
                      <Heading is="h6" variant="normal" color="primary.main" data-testid="total-checkout-value">
                        <MonetaryValue value={total.value} currencyCode={total.currency} />
                      </Heading>
                    </Processing>
                  </Flex>
                )}
                {!isSettleWithAConfirmWithOption && <CorporateBenefitsToggle />}
                {showVoucher && <VoucherSelection />}
                {hasSpotBooking && <SpotBookingInformation />}
                <SummaryButton isSettleWithAConfirmWithOption={isSettleWithAConfirmWithOption} />
              </Flex>
            </Processing>
          </Card>
          {errors &&
            errors.map((error) => (
              <motion.div key={error} initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
                <ErrorBox error={{ type: 'message', message: error }} marginTop="default" />
              </motion.div>
            ))}
          <AvailablePaymentMethods />
        </Flex>
      </Sticky>
    </div>
  )
}

export default DesktopSummary
